import React from 'react';
import { Button } from '../ui/Button';
import { Check, ShieldCheck, Truck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-167">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-168">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl" data-id="element-169" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl" data-id="element-170" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-171">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-172">
          Take Back Your Sleep Now
        </h2>
        <p className="text-2xl text-blue-100 mb-12" data-id="element-173">
          Try Flow Regen for a full 60 nights. If you are not waking up less,
          feeling more rested, or simply are not impressed, contact us for a
          full refund.
        </p>

        <div className="bg-slate-800 text-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform hover:scale-105 transition-transform duration-300 border border-slate-700" data-id="element-174">
          <div className="inline-block bg-red-900/30 text-red-300 px-4 py-1 rounded-full text-base font-bold uppercase tracking-wide mb-6 border border-red-700/50" data-id="element-175">
            Limited Batch • European Sourcing
          </div>

          {/* Product Image */}
          <div className="mb-8 flex items-center justify-center" data-id="element-176">
            <img src="https://cdn.magicpatterns.com/uploads/9oCX1vHKCugLQ5QKm5q23s/13.svg" alt="Flow Regen Prostate Support Drops" className="w-full max-w-sm h-auto" data-id="element-177" />
          </div>

          <h3 className="text-2xl font-bold mb-2" data-id="element-178">Exclusive Online Offer</h3>
          <div className="text-5xl font-bold text-[#e6b500] mb-2" data-id="element-179">Save 82%</div>
          <p className="text-slate-400 text-xl mb-8" data-id="element-180">on the 6-bottle bundle</p>

          <ul className="text-left space-y-4 mb-8 bg-slate-900/50 p-6 rounded-xl border border-slate-700" data-id="element-181">
            <li className="flex items-start" data-id="element-182">
              <Check className="w-5 h-5 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-183" />
              <span className="text-lg font-medium text-slate-300" data-id="element-184">
                Pelvic congestion takes time to resolve — consistency is key.
              </span>
            </li>
            <li className="flex items-start" data-id="element-185">
              <Check className="w-5 h-5 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-186" />
              <span className="text-lg font-medium text-slate-300" data-id="element-187">
                Lock in today's pricing against future ingredient costs.
              </span>
            </li>
            <li className="flex items-start" data-id="element-188">
              <Check className="w-5 h-5 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-189" />
              <span className="text-lg font-medium text-slate-300" data-id="element-190">
                One-time purchase • No automatic subscriptions
              </span>
            </li>
          </ul>

          <Button fullWidth size="lg" variant="primary" onClick={() => window.location.href = 'https://arella.store/products/flow-regen'} className="text-xl py-6 shadow-xl shadow-[#e6b500]/20 mb-4" data-id="element-191">
            CLAIM YOUR DISCOUNT NOW
          </Button>

          <div className="flex items-center justify-center space-x-4 text-base text-slate-400 font-medium" data-id="element-192">
            <span className="flex items-center" data-id="element-193">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-194" /> 60-Day Guarantee
            </span>
            <span className="flex items-center" data-id="element-195">
              <Truck className="w-4 h-4 mr-1" data-id="element-196" /> Free Shipping on 3+ Bottles
            </span>
          </div>
        </div>
      </div>
    </section>;
}